// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LovedIndexRouteImport } from './routes/loved/index'
import { Route as PageIdRouteImport } from './routes/page.$id'
import { Route as CheckinIdRouteImport } from './routes/checkin.$id'
import { Route as VarietalIdIndexRouteImport } from './routes/varietal/$id/index'
import { Route as TitleIdIndexRouteImport } from './routes/title/$id/index'
import { Route as RoasterIdIndexRouteImport } from './routes/roaster/$id/index'
import { Route as RegionIdIndexRouteImport } from './routes/region/$id/index'
import { Route as ProducerIdIndexRouteImport } from './routes/producer/$id/index'
import { Route as ProcessingMethodIdIndexRouteImport } from './routes/processing-method/$id/index'
import { Route as CountryIdIndexRouteImport } from './routes/country/$id/index'
import { Route as CafeIdIndexRouteImport } from './routes/cafe/$id/index'
import { Route as BrewingMethodIdIndexRouteImport } from './routes/brewing-method/$id/index'
import { Route as BrandIdIndexRouteImport } from './routes/brand/$id/index'
import { Route as LovedPagePageRouteImport } from './routes/loved/page/$page'
import { Route as LocationStateIdIndexRouteImport } from './routes/location/state/$id/index'
import { Route as LocationCountryIdIndexRouteImport } from './routes/location/country/$id/index'
import { Route as LocationCityIdIndexRouteImport } from './routes/location/city/$id/index'
import { Route as VarietalIdPagePageRouteImport } from './routes/varietal/$id/page/$page'
import { Route as TitleIdPagePageRouteImport } from './routes/title/$id/page/$page'
import { Route as RoasterIdPagePageRouteImport } from './routes/roaster/$id/page/$page'
import { Route as RegionIdPagePageRouteImport } from './routes/region/$id/page/$page'
import { Route as ProducerIdPagePageRouteImport } from './routes/producer/$id/page/$page'
import { Route as ProcessingMethodIdPagePageRouteImport } from './routes/processing-method/$id/page/$page'
import { Route as CountryIdPagePageRouteImport } from './routes/country/$id/page/$page'
import { Route as CafeIdPagePageRouteImport } from './routes/cafe/$id/page/$page'
import { Route as BrewingMethodIdPagePageRouteImport } from './routes/brewing-method/$id/page/$page'
import { Route as BrandIdPagePageRouteImport } from './routes/brand/$id/page/$page'
import { Route as LocationStateIdPagePageRouteImport } from './routes/location/state/$id/page/$page'
import { Route as LocationCountryIdPagePageRouteImport } from './routes/location/country/$id/page/$page'
import { Route as LocationCityIdPagePageRouteImport } from './routes/location/city/$id/page/$page'

const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LovedIndexRoute = LovedIndexRouteImport.update({
            id: '/loved/',path: '/loved/',getParentRoute: () => rootRouteImport
          })
const PageIdRoute = PageIdRouteImport.update({
            id: '/page/$id',path: '/page/$id',getParentRoute: () => rootRouteImport
          })
const CheckinIdRoute = CheckinIdRouteImport.update({
            id: '/checkin/$id',path: '/checkin/$id',getParentRoute: () => rootRouteImport
          })
const VarietalIdIndexRoute = VarietalIdIndexRouteImport.update({
            id: '/varietal/$id/',path: '/varietal/$id/',getParentRoute: () => rootRouteImport
          })
const TitleIdIndexRoute = TitleIdIndexRouteImport.update({
            id: '/title/$id/',path: '/title/$id/',getParentRoute: () => rootRouteImport
          })
const RoasterIdIndexRoute = RoasterIdIndexRouteImport.update({
            id: '/roaster/$id/',path: '/roaster/$id/',getParentRoute: () => rootRouteImport
          })
const RegionIdIndexRoute = RegionIdIndexRouteImport.update({
            id: '/region/$id/',path: '/region/$id/',getParentRoute: () => rootRouteImport
          })
const ProducerIdIndexRoute = ProducerIdIndexRouteImport.update({
            id: '/producer/$id/',path: '/producer/$id/',getParentRoute: () => rootRouteImport
          })
const ProcessingMethodIdIndexRoute = ProcessingMethodIdIndexRouteImport.update({
            id: '/processing-method/$id/',path: '/processing-method/$id/',getParentRoute: () => rootRouteImport
          })
const CountryIdIndexRoute = CountryIdIndexRouteImport.update({
            id: '/country/$id/',path: '/country/$id/',getParentRoute: () => rootRouteImport
          })
const CafeIdIndexRoute = CafeIdIndexRouteImport.update({
            id: '/cafe/$id/',path: '/cafe/$id/',getParentRoute: () => rootRouteImport
          })
const BrewingMethodIdIndexRoute = BrewingMethodIdIndexRouteImport.update({
            id: '/brewing-method/$id/',path: '/brewing-method/$id/',getParentRoute: () => rootRouteImport
          })
const BrandIdIndexRoute = BrandIdIndexRouteImport.update({
            id: '/brand/$id/',path: '/brand/$id/',getParentRoute: () => rootRouteImport
          })
const LovedPagePageRoute = LovedPagePageRouteImport.update({
            id: '/loved/page/$page',path: '/loved/page/$page',getParentRoute: () => rootRouteImport
          })
const LocationStateIdIndexRoute = LocationStateIdIndexRouteImport.update({
            id: '/location/state/$id/',path: '/location/state/$id/',getParentRoute: () => rootRouteImport
          })
const LocationCountryIdIndexRoute = LocationCountryIdIndexRouteImport.update({
            id: '/location/country/$id/',path: '/location/country/$id/',getParentRoute: () => rootRouteImport
          })
const LocationCityIdIndexRoute = LocationCityIdIndexRouteImport.update({
            id: '/location/city/$id/',path: '/location/city/$id/',getParentRoute: () => rootRouteImport
          })
const VarietalIdPagePageRoute = VarietalIdPagePageRouteImport.update({
            id: '/varietal/$id/page/$page',path: '/varietal/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const TitleIdPagePageRoute = TitleIdPagePageRouteImport.update({
            id: '/title/$id/page/$page',path: '/title/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const RoasterIdPagePageRoute = RoasterIdPagePageRouteImport.update({
            id: '/roaster/$id/page/$page',path: '/roaster/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const RegionIdPagePageRoute = RegionIdPagePageRouteImport.update({
            id: '/region/$id/page/$page',path: '/region/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const ProducerIdPagePageRoute = ProducerIdPagePageRouteImport.update({
            id: '/producer/$id/page/$page',path: '/producer/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const ProcessingMethodIdPagePageRoute = ProcessingMethodIdPagePageRouteImport.update({
            id: '/processing-method/$id/page/$page',path: '/processing-method/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const CountryIdPagePageRoute = CountryIdPagePageRouteImport.update({
            id: '/country/$id/page/$page',path: '/country/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const CafeIdPagePageRoute = CafeIdPagePageRouteImport.update({
            id: '/cafe/$id/page/$page',path: '/cafe/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const BrewingMethodIdPagePageRoute = BrewingMethodIdPagePageRouteImport.update({
            id: '/brewing-method/$id/page/$page',path: '/brewing-method/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const BrandIdPagePageRoute = BrandIdPagePageRouteImport.update({
            id: '/brand/$id/page/$page',path: '/brand/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const LocationStateIdPagePageRoute = LocationStateIdPagePageRouteImport.update({
            id: '/location/state/$id/page/$page',path: '/location/state/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const LocationCountryIdPagePageRoute = LocationCountryIdPagePageRouteImport.update({
            id: '/location/country/$id/page/$page',path: '/location/country/$id/page/$page',getParentRoute: () => rootRouteImport
          })
const LocationCityIdPagePageRoute = LocationCityIdPagePageRouteImport.update({
            id: '/location/city/$id/page/$page',path: '/location/city/$id/page/$page',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,CheckinIdRoute: CheckinIdRoute,PageIdRoute: PageIdRoute,LovedIndexRoute: LovedIndexRoute,LovedPagePageRoute: LovedPagePageRoute,BrandIdIndexRoute: BrandIdIndexRoute,BrewingMethodIdIndexRoute: BrewingMethodIdIndexRoute,CafeIdIndexRoute: CafeIdIndexRoute,CountryIdIndexRoute: CountryIdIndexRoute,ProcessingMethodIdIndexRoute: ProcessingMethodIdIndexRoute,ProducerIdIndexRoute: ProducerIdIndexRoute,RegionIdIndexRoute: RegionIdIndexRoute,RoasterIdIndexRoute: RoasterIdIndexRoute,TitleIdIndexRoute: TitleIdIndexRoute,VarietalIdIndexRoute: VarietalIdIndexRoute,BrandIdPagePageRoute: BrandIdPagePageRoute,BrewingMethodIdPagePageRoute: BrewingMethodIdPagePageRoute,CafeIdPagePageRoute: CafeIdPagePageRoute,CountryIdPagePageRoute: CountryIdPagePageRoute,ProcessingMethodIdPagePageRoute: ProcessingMethodIdPagePageRoute,ProducerIdPagePageRoute: ProducerIdPagePageRoute,RegionIdPagePageRoute: RegionIdPagePageRoute,RoasterIdPagePageRoute: RoasterIdPagePageRoute,TitleIdPagePageRoute: TitleIdPagePageRoute,VarietalIdPagePageRoute: VarietalIdPagePageRoute,LocationCityIdIndexRoute: LocationCityIdIndexRoute,LocationCountryIdIndexRoute: LocationCountryIdIndexRoute,LocationStateIdIndexRoute: LocationStateIdIndexRoute,LocationCityIdPagePageRoute: LocationCityIdPagePageRoute,LocationCountryIdPagePageRoute: LocationCountryIdPagePageRoute,LocationStateIdPagePageRoute: LocationStateIdPagePageRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)